(function() {
  'use strict';

  angular
    .module('scorm.scormCtrl', ['utils.urlUtil', 'factories.authProvider'])
    .controller('ScormCtrl', ScormCtrl);

  ScormCtrl.$inject = ['$scope', '$sce', 'scormModel', 'scormService', 'trainerPreview', 'Auth', 'scormCommService'];

  function ScormCtrl($scope, $sce, scormModel, scormService, trainerPreview, Auth, scormCommService) {
    var currentSlide = $scope.currentSlide;
    var previewMode;
    var navigation;
    var smePreview;

    if (!$scope.currentSlide) {
      console.log('scormCtrl :: currentSlide is not defined');
    }

    previewMode = ($scope.account.role === Auth.userRoles.sme) || trainerPreview;
    navigation = $scope.navigation;

    if (navigation.playerType === 'trainerPreviewGoodData') {
      $scope.thumbUrl = $scope.currentSlide.largeThumbnailPath;
      return;
    }

    scormModel.setPlayerUrl(mfConfig.scormPath);
    scormModel.setContentUrl($scope.currentSlide.contentUrl);
    scormModel.trustedPlayerUrl = $sce.trustAsResourceUrl(scormModel.playerUrl);
    scormModel.scormType = $scope.currentSlide.scormType;
    scormModel.quiz = currentSlide.__type === 'ScoQuizSlideInfo';
    $scope.scormModel = scormModel;
    smePreview = $scope.account.role === Auth.userRoles.sme;

    $scope.state = {
      name: scormCommService.setScoIncomplete()
    };

    $scope.sendMessage = function(cb) {
      scormCommService.sendMessage = cb;
    };

    $scope.receiveMessage = function(data) {
      if (data.type === 'requestSetup') {
        requestSetup();
      }

      if (data.type === 'requestScoPropertiesSave') {
        currentSlide.scoProperties = data.message;
        requestScoPropertiesSave();
      }

      if (data.type === 'scoComplete') {
        $scope.state.name = scormCommService.setScoComplete();
        setScopeState();
      }
    };

    function requestSetup() {
      currentSlide.scoProperties = currentSlide.scoProperties || {};
      scormCommService.requestSetup(currentSlide.scoProperties, scormModel.contentUrl, scormModel.scormType);
      setScopeState();
    }

    function requestScoPropertiesSave() {
      // do not save when in preview mode
      if (previewMode)
        $scope.advanceSlideProgress({});
      else
        saveScoProperties();

      setScopeState();
    }

    function saveScoProperties() {
      scormService.saveScoProperties({
        cModuleId: $scope.cModuleId,
        courseId: $scope.courseId,
        frameId: currentSlide.id,
        quiz: scormModel.quiz,
        scormType: scormModel.scormType,
        scoProperties: currentSlide.scoProperties
      }, function(frameStateInfo) {
        if (!currentSlide)
          $scope.advanceSlideProgress({});

        if (frameStateInfo && currentSlide.status !== frameStateInfo.status) {
          $scope.advanceSlideProgress({});
          currentSlide.status = frameStateInfo.status;
        }
      });
    }

    navigation.intercept('canNavigate', function interceptCanNavigate(navigateTo) {
      if (trainerPreview || smePreview)
        return true;

      if (navigateTo === navigation.directions.next)
        return $scope.state.name === 'ready';

      return true;
    });

    function setScopeState() {
      if (_.isEmpty(currentSlide.scoProperties)) {
        return;
      }

      var stateName = scormCommService.checkScoComplete(currentSlide.scoProperties, scormModel.scormType);
      if (stateName) {
        $scope.state.name = stateName;
      }
    }

    setScopeState();
  }
})();
